import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiFetchHandlerListByImpc = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getHandlerListByImpcDefault',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      impcCode: payload.params,
    },
  });
  return axios.get(serviceURL);
};

export const apiPostAssociateHandlerDefault = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'associateHandlerDefault',
    stub: process.env.useStubbedEndpoints,
    pathParameters: { mrdName: payload.mrdName },
  });
  return axios.post(serviceURL, { associateHandlerCommandList: payload.handlerList });
};
